import { createStore } from 'vuex'

const defaultSeason = process.env.VUE_APP_DEFAULT_SEASON || '2025-2026'

export default createStore({
  state: {
    teams: [],
    seasons: [],
    selectedSeason: defaultSeason,
    loading: false
  },
  mutations: {
    SET_TEAMS(state, teams) {
      state.teams = teams
    },
    SET_SEASONS(state, seasons) {
      state.seasons = seasons
    },
    SET_SELECTED_SEASON(state, season) {
      state.selectedSeason = season
    },
    SET_LOADING(state, loading) {
      state.loading = loading
    }
  },
  actions: {
    async fetchTeams({ commit, state }) {
      commit('SET_LOADING', true)
      try {
        const params = state.selectedSeason ? `?season=${encodeURIComponent(state.selectedSeason)}` : ''
        const response = await fetch(`/api/teams${params}`)
        const data = await response.json()
        commit('SET_TEAMS', data.data)
      } catch (error) {
        console.error('Error fetching teams:', error)
      } finally {
        commit('SET_LOADING', false)
      }
    },
    async fetchSeasons({ commit, state }) {
      if (state.seasons.length) {
        return
      }
      try {
        const response = await fetch('/api/seasons')
        const data = await response.json()
        if (data.success && data.data) {
          commit('SET_SEASONS', data.data.seasons || [])
          if (!state.selectedSeason && data.data.defaultSeason) {
            commit('SET_SELECTED_SEASON', data.data.defaultSeason)
          }
        }
      } catch (error) {
        console.error('Error fetching seasons:', error)
      }
    },
    setSelectedSeason({ commit }, season) {
      commit('SET_SELECTED_SEASON', season)
    }
  }
})
